import gql from 'graphql-tag';

const CREATE_SERVICE_ITEM = gql`
  mutation($item: ServiceItemInput) {
    createServiceItem(item: $item) {
      itemId
      name
      invoiceDescription
      quantityType
      roundUpValue
      unitPrice
      costPrice
      category {
        categoryId
        name
      }
      businessHoursUnitPrice
      afterHoursUnitPrice
      useAsWorklogItem
      quantity
      integrationState {
        xero
        quickbooks
        pax8
      }
      salesTax {
        taxId
        name
        rates {
          rateId
          name
          rateValue
        }
      }
      salesTaxEnabled
    }
  }
`;

const UPDATE_SERVICE_ITEM = gql`
  mutation($itemId: ID!, $item: ServiceItemInput) {
    updateServiceItem(item: $item, itemId: $itemId) {
      itemId
      name
      invoiceDescription
      quantityType
      roundUpValue
      unitPrice
      costPrice
      category {
        categoryId
        name
      }
      businessHoursUnitPrice
      afterHoursUnitPrice
      useAsWorklogItem
      quantity
      salesTaxEnabled
      salesTax {
        taxId
        name
      }
      integrationState {
        xero
        quickbooks
        pax8
      }
    }
  }
`;

const CREATE_SERVICE_ITEM_FOR_IT = gql`
  mutation($item: ServiceItemInput) {
    createServiceItem(item: $item) {
      itemId
      name
      invoiceDescription
      category {
        categoryId
        name
      }
    }
  }
`;

const UPDATE_SERVICE_ITEM_FOR_IT = gql`
  mutation($itemId: ID!, $item: ServiceItemInput) {
    updateServiceItem(item: $item, itemId: $itemId) {
      itemId
      name
      invoiceDescription

      category {
        categoryId
        name
      }
    }
  }
`;

const DELETE_SERVICE_ITEM = gql`
  mutation($itemId: ID!) {
    deleteServiceItem(itemId: $itemId)
  }
`;

const DELETE_SERVICE_ITEMS = gql`
  mutation($itemIds: [ID!]!) {
    deleteServiceItems(itemIds: $itemIds)
  }
`;

const CREATE_SERVICE_CATEGORY = gql`
  mutation($category: ServiceCategoryInput!) {
    createServiceCategory(category: $category) {
      categoryId
      name
    }
  }
`;

const UPDATE_SERVICE_CATEGORY = gql`
  mutation($categoryId: ID!, $category: ServiceCategoryInput!) {
    updateServiceCategory(categoryId: $categoryId, category: $category) {
      categoryId
      name
    }
  }
`;

const DELETE_SERVICE_CATEGORY = gql`
  mutation($categoryIds: [ID!]!) {
    deleteServiceCategories(categoryIds: $categoryIds)
  }
`;

export {
  CREATE_SERVICE_ITEM,
  UPDATE_SERVICE_ITEM,
  DELETE_SERVICE_ITEM,
  DELETE_SERVICE_ITEMS,
  CREATE_SERVICE_CATEGORY,
  UPDATE_SERVICE_CATEGORY,
  DELETE_SERVICE_CATEGORY,
  CREATE_SERVICE_ITEM_FOR_IT,
  UPDATE_SERVICE_ITEM_FOR_IT
};
